import LeftMenu from 'components/Dashboard/LeftMenu';
import { useMediaQuery } from 'usehooks-ts';
import { NAV_IS_MOBILE_MAX_WIDTH } from 'utils/constants';
import MobileMenu from './MobileMenu';
import { useLocation } from 'react-router-dom';

interface SideNavLayoutProps {
  children: React.ReactNode;
}

const SideNavLayout = ({ children }: SideNavLayoutProps) => {
  const location = useLocation();
  const isMobile = useMediaQuery(`(max-width: ${NAV_IS_MOBILE_MAX_WIDTH}px)`);
  const showDefaultHeader = [
    '/get-started',
    '/orders',
    '/invoices',
    '/products',
    '/prices',
    '/partners',
    '/requests',
    '/reporting',
    '/issues',
    '/settings',
  ].some((route) => location.pathname.includes(route));

  return (
    <>
      {isMobile ? <MobileMenu showDefaultHeader={showDefaultHeader} /> : <LeftMenu />}
      {children}
    </>
  );
};

export default SideNavLayout;
